import { Transition } from '@uirouter/core';
import { Action } from '../../common/actions/core/action';
import { PaymentMethod } from '../services/payment-method.model';

export class CardDeleteSuccessAction implements Action {
  constructor() {}
}



// WEBPACK FOOTER //
// src/app/buy/card-delete-success-dialog/card-delete-success-dialog.action.ts